import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// Renders a NavItem with active class based on current path
class ActiveNavItem extends React.Component {
  static propTypes = {
    path: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  };

  isActive = () => {
    const { pathname } = this.props.location;

    return pathname.includes(this.props.path) ? 'active' : '';
  };

  render() {
    return (
      <li className={`nav-item ${this.isActive()}`}>{this.props.children}</li>
    );
  }
}

export default withRouter(ActiveNavItem);
